import { createFileRoute, redirect } from '@tanstack/react-router'
// import { InvoicesPage } from '@/features/finance/invoices/pages/invoices-page'
// import { requireRole } from '@/lib/auth-guards'

/** Invoices are temporarily disabled; redirect manual URL access to home. */
export const Route = createFileRoute('/_authenticated/invoices/')({
  // component: InvoicesPage,
  // beforeLoad: requireRole(['admin']),
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true })
  },
})
